// ─────────────────────────────────────────────────────────────────────────────
// Shared primitives for the Home page sections.
// Design scale: 1rem = 8px (root font-size: calc(800vw / 1920)).
// CTAs use the design-system <CTAButton /> from "@/shadcn/ui/button".
// ─────────────────────────────────────────────────────────────────────────────

/** Decorative "| | | LABEL | | |" pipe chip (Space Mono, uppercase). */
export function PipeChip({
  children,
  color = "#b8d2e2",
  className = "",
  hideRight = false,
}: {
  children: React.ReactNode;
  color?: string;
  className?: string;
  hideRight?: boolean;
}) {
  return (
    <p
      className={`font-spacemono text-[1.75rem] uppercase tracking-[0.025rem] ${className}`}
      style={{ color }}>
      <span style={{ color, opacity: 0.2 }}>|</span>
      <span style={{ color, opacity: 0.4 }}>|</span>
      <span style={{ color, opacity: 0.6 }}>|</span>
      <span style={{ color, opacity: 0.8 }}> {children} </span>
      {!hideRight && (
        <>
          <span style={{ color, opacity: 0.6 }}>|</span>
          <span style={{ color, opacity: 0.4 }}>|</span>
          <span style={{ color, opacity: 0.2 }}>|</span>
        </>
      )}
    </p>
  );
}

/** 45°-up arrow (used by the footer back-to-top control). */
export const ArrowIcon = ({ className = "" }: { className?: string }) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    className={`h-[2.25rem] w-[1.875rem] rotate-90 ${className}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7945 7.39726L13.7515 8.44027L8.13699 2.83315V17.7534H6.65753V2.83315L1.04301 8.44027L0 7.39726L7.39726 0L14.7945 7.39726Z"
      fill="black"
    />
  </svg>
);
